import React, { Component } from "react";
import { Formik } from "formik";
import { server } from "../../../constants";
import {
  Row,
  Col,
  FormInput,
  FormTextarea
} from "shards-react";
import * as actions from "../../../actions/meeting.action";
import { connect } from "react-redux";
import { httpClient } from "../../../utils/HttpClient";
import Swal from "sweetalert2";
import { apiUrl } from "../../../config/index"
import moment, { relativeTimeThreshold } from "moment";
import { isBrowser, isMobile } from "react-device-detect";
import { Button, Drawer, Modal, message, Descriptions, Tooltip, Avatar } from 'antd';
import {
  EditOutlined
} from '@ant-design/icons';
import jwt_decode from "jwt-decode";

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class ViewReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meeting: '',
      drawerVisible: false,
      drawerCommentVisible: false,
      emailModalVisible: false,
      validating: false,
      isValidated: false,
      isValidateError: false,
      id: '',
      password: '',
      email: '',
      name: '',
      commentAgenda: '',
      commentDesc: '',
      comments: [],
      totalPages: 0
    };
  }

  async componentDidMount() {
    try {
      this.setState({
        emailModalVisible: true
      })
    } catch(err)  {
      
    }
  }

  async loginWithEmail()  {
    if(!this.state.email)  {
      message.error('กรุณากรอกอีเมล');

      return
    }

    try {
      const response = await httpClient.post(
        `/api/authentication/email`,
        { 
          email: this.state.email 
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.setItem("token", response.data)
      const user = jwt_decode(response.data);
      localStorage.setItem('user_profile',JSON.stringify(user));      

      return true
    } catch(err)  {
      if(err.response.status === 404) {
        message.error('ไม่พบอีเมลนี้ในระบบ');
      }

      return false
    }
  }

  async validate()  {
    this.setState({validating: true})
    
    if(this.state.email)  {
      try {
        const params = {
          email: this.state.email,
          password: this.state.password,
          type: '5'
        }

        const response = await httpClient.post(`${server.MEETING_URL}/${this.props.match.params.id}/preview/authen`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        
        if(response.data.isValid) {
          const isLogin = await this.loginWithEmail()

          if(isLogin) {
            this.setState({
              id: response.data.id,
              name: response.data.name,
              isValidated: true,
              validating: false,
              emailModalVisible: false
            })

            window.location.href = response.data.url;
          } else {
            message.error('อีเมลหรือรหัสผ่านไม่ถูกต้อง');  
          }
        } else {
          message.error('อีเมลหรือรหัสผ่านไม่ถูกต้อง');
        }
      } catch(err)  {
        message.error('เกิดข้อผิดพลาดในการยืนยันตัวตน กรุณาลองใหม่อีกครั้ง');
      }

      this.setState({
        validating: false
      })
    } else {
      message.error('กรุณากรอกอีเมลผู้เข้าประชุม');

      this.setState({
        validating: false
      })
    }
  }

  render() {
    return (
      <div className={"preview-container"}>
        <Drawer
          width={400}
          title="เพิ่มประเด็นอภิปราย"
          placement="right"
          closable={false}
          onClose={() => this.setState({drawerVisible: false})}
          visible={this.state.drawerVisible}
          footer={
            <div className="text-right">
              <Button 
                type="primary" 
                htmlType="button" 
                className="mr-2"
                style={{width: 100}}
                onClick={() => this.saveComment()}
              >
                บันทึก
              </Button>
              <Button 
                htmlType="button" 
                style={{width: 100}}
                onClick={() => this.setState({
                  commentAgenda: '',
                  commentDesc: ''
                })}
              >
                ยกเลิก
              </Button>
            </div>
          }
        > 
          <div className="d-flex align-items-center">
            <div className="flex-fill mr-2">
              <Descriptions column={2}>
                <Descriptions.Item label="ชื่อผู้เข้าประชุม">{ this.state.name }</Descriptions.Item>
              </Descriptions>
            </div>
            <Tooltip title="แก้ไขชื่อผู้เข้าประชุม">
              <div 
                className="pointer"
                style={{paddingBottom: 16}}
                onClick={() => this.setState({
                  emailModalVisible: true,
                  drawerVisible: false
                })}
              >
                <EditOutlined style={{ fontSize: '18px' }}/>
              </div>
            </Tooltip>
          </div>

          <hr className="mt-1" />
           
          <Row form>
            <Col md="12" className="form-group">
              <label>ระบุระเบียบวาระ</label>
              <FormInput
                name="commentAgenda"
                id="commentAgenda"
                value={this.state.commentAgenda}
                onChange={(e) => this.setState({commentAgenda: e.target.value})}
              />
            </Col>
          </Row>
          <Row form>
            <Col md="12" className="form-group">
              <label>ข้อเสนอแนะ / ข้อคิดเห็น / ประเด็นอภิปราย</label>
              <FormTextarea
                rows="5"
                name="commentDesc"
                id="commentDesc"
                value={this.state.commentDesc}
                onChange={(e) => this.setState({commentDesc: e.target.value})}
              />
            </Col>
          </Row>
        </Drawer>

        <Drawer
          width={400}
          title="ประเด็นอภิปราย"
          placement="right"
          closable={false}
          onClose={() => this.setState({drawerCommentVisible: false})}
          visible={this.state.drawerCommentVisible}
          footer={null}
        > 
          { 
            this.state.comments && this.state.comments.map(item => { 
              return (
                <div className="d-flex flex-column mb-4 pb-2">
                  <div className="d-flex align-items-center">
                    <div className="text-muted">{item.name}</div>
                    <span className="mx-1" style={{width:4, height:4, borderRadius: '50em', backgroundColor:'#bbb', marginTop: 4}}/>
                    <Tooltip title={moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}>
                      <span className="text-muted">{moment(item.createdAt).fromNow()}</span>
                    </Tooltip>
                  </div>
                  <div className="d-flex mt-2">
                    <div className="font-weight-bold mr-3">วาระที่ {item.agenda}:</div>
                    <p className="mb-0">{item.description}</p>
                  </div>
                </div>
              )
            }) 
          }
        </Drawer>

        <Modal
          centered
          title="ยืนยันตัวตน"
          visible={this.state.emailModalVisible}
          closable={false}
          maskClosable={this.state.name}
          onCancel={() => this.setState({emailModalVisible: false})}
          footer={
            <Button 
              type="primary" 
              loading={this.state.validating}
              onClick={() => {
                this.validate()
              }}
            >
              เข้าสู่การประชุม
            </Button>
          }
        > 
          <Row form>
            <Col md="12" className="form-group">
              <label>อีเมลผู้เข้าประชุม</label>
              <FormInput
                name="email"
                id="email"
                value={this.state.email}
                onChange={(e) => this.setState({email: e.target.value})}
              />
            </Col>
          </Row>

          <Row form>
            <Col md="12" className="form-group">
              <label>รหัสผ่าน</label>
              <FormInput
                name="password"
                id="password"
                type="password"
                value={this.state.password}
                onChange={(e) => this.setState({password: e.target.value})}
              />
            </Col>
          </Row>
        </Modal>        
      </div>
    );
  }
}

const mapStateToProps = ({ meetingReducer }) => ({ meetingReducer });

const mapDispatchToProps = {
  ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewReport);
